import { AuthService } from '../../../auth/auth.service';

import {
	Component,
	inject,
	input,
	OnDestroy,
	OnInit,
	Renderer2
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LayoutService } from '../../services/layout.service';
import { MainProductServices } from '../../services/main-product.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatLabel, MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationService } from '../../../shared/services/navigation.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';
import { ThemeService } from '../../../shared/services/theme.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-header-top',
	templateUrl: './header-top.component.html',
	standalone: true,
	imports: [
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatTooltipModule,
		MatSidenavModule,
		MatSelectModule,
		FormsModule,
		TranslateModule,
		MatLabel,
		RouterLink,
		RouterLinkActive
	]
})
export class HeaderTopComponent implements OnInit, OnDestroy {
	private authService = inject(AuthService);
	private layout = inject(LayoutService);
	private navService = inject(NavigationService);
	private renderer = inject(Renderer2);
	private typeService = inject(MainProductServices);
	r = inject(Router);
	themeService = inject(ThemeService);
	translate = inject(TranslateService);

	layoutConf: any;
	menuItems: any;
	menuItemSub: Subscription;
	egretThemes: any[] = [];
	typeTarif: string = "Vida Ley";
	currentLang = 'en';
	availableLangs = [
		{
			name: 'English',
			code: 'en'
		},
		{
			name: 'Spanish',
			code: 'es'
		}
	];
	readonly notificPanel = input<MatSidenav>();
	readonly tarifarioPanel = input<MatSidenav>();
	readonly titleMenu = input<string>('Menú');

	ngOnInit() {
		if (this.typeService.getMainProduct() != null) {
			// this.typeTarif = (this.typeService.getMainProduct() === 'SCTR') ? 'SCTR' : 'SOAT';
			// this.typeTarif = (this.typeService.getMainProduct() === 'SCTR') ? 'SCTR' : 'SOAT';
		}
		this.layoutConf = this.layout.layoutConf;
		this.egretThemes = this.themeService.egretThemes;
		this.menuItemSub = this.navService.menuItems$.subscribe(res => {
			res = res.filter(item => item.type !== 'icon' && item.type !== 'separator');
			const limit = 6;
			const mainItems: any[] = res.slice(0, limit);
			if (res.length <= limit) {
				return (this.menuItems = mainItems);
			}
			const subItems: any[] = res.slice(limit, res.length - 1);
			mainItems.push({
				name: 'More',
				type: 'dropDown',
				tooltip: 'More',
				icon: 'more_horiz',
				sub: subItems
			});
			this.menuItems = mainItems;
		});
	}

	ngOnDestroy() {
		this.menuItemSub.unsubscribe();
	}

	/* setLang() {
		this.translate.use(this.currentLang);
	} */
	changeTheme(theme) {
		this.themeService.changeTheme(this.renderer, theme);
	}

	togglrTarifario(change: any) {
		if (change === "SOAT") {
			this.typeService.saveMainProduct("SOAT");
		} else {
			this.typeService.saveMainProduct("SCTR");
		}
		if (window.location.pathname === "/dashboard") {
			window.location.reload();
		} else {
			this.r.navigate(["/dashboard"]);
		}

	}

	goInicio() {
		this.r.navigate(["/dashboard"]);
	}

	toggleNotific() {
		this.notificPanel()?.toggle();
	}

	toggleNotificSw() {
		this.tarifarioPanel()?.toggle();
	}

	toggleSidenav() {
		if (this.layoutConf.sidebarStyle === 'closed') {
			return this.layout.publishLayoutChange({
				sidebarStyle: 'full'
			});
		}
		this.layout.publishLayoutChange({
			sidebarStyle: 'closed'
		});
	}

	logout() {
		this.authService.signOut();
	}
}
